// DOCTOR_LIST
export const DOCTOR_LIST_REQUESTING = "DOCTOR_LIST_REQUESTING"
export const DOCTOR_LIST_SUCCESS = "DOCTOR_LIST_SUCCESS"
export const DOCTOR_LIST_ERROR = "DOCTOR_LIST_ERROR"
